/**
 * Get the current application version from environment variables
 * Falls back to 'development' if not set
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'development'

/**
 * Checks if the application version has changed and forces a cache refresh if needed
 * @returns {Promise<boolean>} True if cache was cleared, false otherwise
 */
export const checkAppVersion = async () => {
  // Get the last known version from localStorage
  const lastVersion = localStorage.getItem('appVersion')

  // Only perform check if we have a real version and it's different from the stored one
  if (APP_VERSION !== 'development' && lastVersion !== APP_VERSION) {
    console.log(`App version changed from ${lastVersion || 'initial'} to ${APP_VERSION}`)

    // Store the new version
    localStorage.setItem('appVersion', APP_VERSION)

    // Clear browser caches
    if ('caches' in window) {
      try {
        const cacheNames = await caches.keys()
        await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
        console.log('Application cache cleared successfully')
      } catch (error) {
        console.error('Error clearing cache:', error)
      }
    }

    // Force reload the page to ensure fresh content
    window.location.reload(true)
    return true
  }

  return false
}
